import React from 'react'
import styled from 'styled-components'
import { splitFilename } from './utils'
import Tooltip from '../tooltip'
import { useMutation } from '@apollo/react-hooks'
import MarkFileAsRead from '../../queries/MarkFileAsRead'

const Variant = {
  NEW: 'NEW',
  ARCHIVE: 'ARCHIVE',
}

const FilenameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 2px 0;
`

const LinkElement = styled.a`
  color: #1e88e5;
  text-decoration: none;
  font-weight: 600;

  ${(props) => props.variant === Variant.ARCHIVE && `color: #78787B;`}

  &:hover {
    text-decoration: underline;
  }
`

const BadgeElement = styled.div`
  background-color: #e67600;
  border-radius: 4px;
  color: white;
  font-size: 0.5rem;
  padding: 0 0.2rem;
  cursor: default;
  line-height: 12px;

  ${(props) =>
    props.children === Variant.ARCHIVE && `background-color: #9A9A9C;`}
`

const MAX_FILENAME_TEXT_LENGTH = 26

function Filename({
  documentId,
  filename,
  originalFilename,
  fileUrl,
  isNew,
  archived,
}) {
  const [cleanFilename, extension] = splitFilename(originalFilename)
  const shortFilename = cleanFilename.slice(0, MAX_FILENAME_TEXT_LENGTH)
  const showTooltip = shortFilename !== cleanFilename

  const [markFileAsReadMutation] = useMutation(MarkFileAsRead, {
    variables: {
      input: {
        documentId,
        fileName: filename,
      },
    },
  })

  const handleClick = () => isNew && markFileAsReadMutation()

  const variant = archived ? Variant.ARCHIVE : isNew ? Variant.NEW : null

  return (
    <FilenameWrapper>
      {variant && <BadgeElement>{variant}</BadgeElement>}
      <Tooltip text={showTooltip ? originalFilename : null}>
        <LinkElement
          onClick={handleClick}
          target="_blank"
          href={fileUrl}
          variant={variant}
        >
          {shortFilename}
          {showTooltip && '..'}
          {extension}
        </LinkElement>
      </Tooltip>
    </FilenameWrapper>
  )
}

export default Filename
